import apiClient from './client';

export interface ProductFilters {
	type?: number;
	brand?: number;
	search?: string;
	ids?: string;
	vehicle_id?: number;
}

export interface Product {
	id: number;
	name: string;
	product_type: number;
	product_code: string;
	price: number;
	image: string;
	description: string;
	brand: string;
	brand_id: number;
	voltage: number;
	capacity: number;
	cca: number;
	length: number;
	width: number;
	height: number;
	terminal_type: number;
	terminal_layout: number;
	battery_technology: number;
	warranty: number;
	care_type: number;
	review_quality: number;
	review_trust: number;
	review_price: number;
	review_lifespan: number;
}

export function productSlug(product: Product): string {
	return product.name
		.toLowerCase()
		.replace(/[áà]/g, 'a').replace(/[éè]/g, 'e').replace(/[íì]/g, 'i')
		.replace(/[óòöő]/g, 'o').replace(/[úùüű]/g, 'u')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');
}

export const getProducts = (filters?: ProductFilters) =>
	apiClient.get('/product', { params: filters });

export const getProductById = (id: number) =>
	apiClient.get('/product', { params: { ids: String(id) } });

export const getBatteryList = (vehicleId: number) =>
	apiClient.get('/battery/list', { params: { vehicle_id: vehicleId } });
